import React, { FC } from 'react';
import { makeStyles }  from 'tss-react/mui';
import Collapse, {CollapseProps} from '@mui/material/Collapse'
import Box, {BoxProps} from '@mui/material/Box'
import { Theme } from "@mui/material/styles"

let CollapseEx: FC<CollapseProps & BoxProps> = Collapse as any;
CollapseEx.defaultProps = {
  component: Box,
  position: 'sticky',
  bottom: '0',
  bgcolor: 'transparent',
  right: 0,
};

type ActionBarProps = {
    show?: boolean;
    children: any;
};

const useStyles = makeStyles()((theme: Theme) =>
({
    acb: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(0, 1),
        backdropFilter: 'blur(5px)',
        zIndex: 1000
    },
}));

const ActionBar: FC<ActionBarProps> = ({ children, show, ...props }) => {
  const { classes } = useStyles();

  return (
    <CollapseEx in={show} component={Box} position="sticky">
      <div className={classes.acb}>{children}</div>
    </CollapseEx>
  );
};

type ActionBarStyleProps = Omit<ActionBarProps, 'show'>;

ActionBar.defaultProps = { show: true };

export default ActionBar;
